import React from 'react';
import { Link } from 'react-router-dom';
import M from 'materialize-css';
import Dropdown from '../Dropdown/index';
//import M from 'materialize-css';

import './css/styles.css';

class NavBar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            url_banner_inicio: '',
        };
    }

    componentWillMount(){
        fetch('/api/uip/imagenes/banner', {
            method: 'GET',
            headers: {
                'Content-type': 'application-json'
            }
        })
            .then(response => response.json())
            .then(response => {
                this.setState({
                    url_banner_inicio: response[0].url,
                })
            })

    }

    render() {

        return (
            <div className="container-nav">
                <nav className="nav-hidden">
                    <ul>
                        <li><Link to="/inicio" className="font-nav">Inicio</Link></li>
                        <li><Link to="/especiales" className="font-nav">Especiales</Link></li>
                        <li><Link to="/publicaciones" className="font-nav">Publicaciones</Link></li>
                        <li><Link to="/launidad" className="font-nav">La Unidad</Link></li>
                        <li><Link to="/noshizofeliz" className="font-nav">Nos hizo feliz</Link></li>
                        <li>
                            <a href={this.state.url_banner_inicio} 
                               target="_blank" 
                               className="font-nav">
                                Sin Reclutamiento
                            </a>
                        </li>
                    </ul>
                </nav>
                <div className="drop-hidden">
                    <Dropdown />
                    <div className="nav_icons_right">
                        <a href="https://twitter.com/Guerrayescuela" target="_blank">
                            <span className="icon-instagram-with-circle nav_custom_icons"></span>
                        </a>
                        <a href="https://twitter.com/Guerrayescuela" target="_blank">
                            <span className="icon-twitter-with-circle nav_custom_icons"></span>
                        </a>
                        <a href="https://www.youtube.com/channel/UCT1VKetR5dkLyrzNH_ZGXNw" target="_blank">
                            <span className="icon-youtube-with-circle nav_custom_icons"></span>
                        </a>
                    </div>
                </div>
                
            </div>
        );
    }
}

export default NavBar;